var React = require('react');

function Eye4 (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M210,0v138.3c0,17.8,0,71.7,0,71.7s-49.4,0-70.9,0H0L0,71.7C0,32.2,31.8,0,70.9,0H210z M178.5,31.5H70.9\n\tc-21.7,0-39.4,18-39.4,40.2l0,106.8h147V31.5z M178.5,31.5"}));
}

Eye4.defaultProps = {"version":"1.2","baseProfile":"tiny","id":"Layer_1","x":"0px","y":"0px","viewBox":"0 0 210 210","xmlSpace":"preserve"};

module.exports = Eye4;

Eye4.default = Eye4;
